import {INTERVENE_JS_DEVICE_QUERY} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/intervene/ipDeviceQuery/index.vue'),
    path: 'jsDeviceQuery',
    name: INTERVENE_JS_DEVICE_QUERY,
    meta: {
        title: 'IP/指纹查询',
        name: INTERVENE_JS_DEVICE_QUERY
    }
};